import React from 'react';

/**
 * Componente para mostrar estados de carga con mensajes personalizados
 */
const LoadingState = ({ 
  message = 'Cargando...', 
  subtitle = null, 
  color = 'primary',
  size = 'normal' 
}) => {
  const sizeClass = size === 'large' ? 'spinner-border' : 'spinner-border spinner-border-sm';
  
  return (
    <div className="container-fluid">
      <div className="text-center py-5">
        <div className={`${sizeClass} text-${color}`} role="status">
          <span className="visually-hidden">{message}</span>
        </div>
        <p className="mt-3">
          <strong>{message}</strong>
        </p>
        {subtitle && (
          <small className="text-muted">
            {subtitle}
          </small>
        )}
      </div>
    </div>
  );
};

/**
 * Componente para mostrar estados de error con diferentes tipos
 */
const ErrorState = ({
  title,
  message,
  type = 'danger', // 'danger', 'warning', 'info'
  icon = null,
  actions = null,
  details = null
}) => {
  const getIcon = () => {
    if (icon) return icon;
    
    switch (type) {
      case 'warning':
        return 'fa-exclamation-triangle';
      case 'info':
        return 'fa-info-circle';
      default:
        return 'fa-exclamation-circle';
    }
  };

  const getAlertClass = () => {
    switch (type) {
      case 'warning':
        return 'alert-warning';
      case 'info':
        return 'alert-info';
      default:
        return 'alert-danger';
    }
  };

  return (
    <div className="container-fluid">
      <div className={`alert ${getAlertClass()} text-center`}>
        <h4>
          <i className={`fas ${getIcon()} me-2`}></i>
          {title}
        </h4>
        
        <p className="mb-3">{message}</p>
        
        {details && (
          <div className="text-start">
            {typeof details === 'string' ? (
              <pre style={{ fontSize: '0.875rem' }}>{details}</pre>
            ) : (
              details
            )}
          </div>
        )}
        
        {actions && (
          <div className="mt-3">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export { LoadingState, ErrorState };